export function imageSetForPNG(original) {
    const avifURL = original.replace('.png', '.avif');
    const jxlURL = original.replace('.png', '.jxl');
    return 'image-set(url("' + jxlURL + '") type("image/jxl"), ' + 
    'url("' + avifURL + '") type("image/avif"), ' + 'url("' + original + '") type("image/png"))';
}